import * as React from 'react';
import { observer } from 'mobx-react';
import { BasePayRangeId, BasePayRangeIdNumber } from 'typings/enums';
import StatusSummaryButton from 'nomst/Components/SummaryDashboard/statusSummaryButton';

export interface IBasePayRangeSummaryViewProps {
    basePayRangeSummaries: IStatusSummary[];
}

export class BasePayRangeSummaryView extends React.Component<IBasePayRangeSummaryViewProps> {
    render(): React.ReactNode {
        const { basePayRangeSummaries } = this.props;
        return (
            <div className="pay-range-employees">
                <h2 className="pay-range-employees__heading">Employee Base Pay Range</h2>
                <p className="pay-range-employees__pay-range-divider">
                    <span>Pay Range</span>
                </p>
                <div className="pay-range-employees__summaries">
                    {this.renderBasePayRangeSummaries(basePayRangeSummaries)}
                </div>
            </div>
        );
    }

    renderBasePayRangeSummaries(statusSummaries: IStatusSummary[]): React.ReactNode {
        return statusSummaries.map(statusSummary => {
            const managerViewId = this.convertBaseRangeToNumber(statusSummary.status);
            const uniqueClassString =
                `pay-range-employees__category--${statusSummary.status.trim().replace(' ', '-').toLowerCase()}`;
            return (
                <div
                    className={`pay-range-employees__category ${uniqueClassString}`}
                    key={statusSummary.status}
                >
                    <p className="pay-range-employees__category-name">
                        {statusSummary.status}
                    </p>
                    <p className="pay-range-employees__count">
                        <StatusSummaryButton
                            statusSummary={statusSummary}
                            managerViewId={managerViewId}
                        />
                    </p>
                </div>
            );
        });
    }

    convertBaseRangeToNumber(range: string): number {
        switch (range) {
            case BasePayRangeId.BelowMin:
                return BasePayRangeIdNumber.BelowMin;
            case BasePayRangeId.WithinRange:
                return BasePayRangeIdNumber.WithinRange;
            case BasePayRangeId.AboveMax:
                return BasePayRangeIdNumber.AboveMax;
            default:
                return BasePayRangeIdNumber.BelowMin;
        }
    }
}

export default observer(BasePayRangeSummaryView);